import $ from 'jquery';
import Croppie from './../vendors/croppie';
import decodeHtml from './../helpers/decodeHtml';
import exif from 'exif-js';
import UAParser from 'ua-parser-js';

class Uploader {
  constructor(imageUploader) {
    this.croppie = null;
    this.imageUploader = imageUploader;

    this.context = {
      lang: null,
      context_id: null,
      media_type: 'products',
      collection_name: null,
      media_details: {
        url: null,
        id: null
      }
    };

    this.userBrowser = new UAParser(navigator.userAgent).getBrowser();

    this.init();
  }

  _setContext() {
    this.context.lang = $('html').attr('lang');
    this.context.context_id = $(this.loaderInput).data('context-id');
    this.context.collection_name = $(this.loaderInput).data('collection');

    if ( $(this.loaderInput).attr('filename') ) {
      this.context.media_details.url = $(this.loaderInput).attr('filename');
      this.context.media_details.id = $(this.loaderInput).attr('id');
    }

    this.context.media_type = $(this.loaderInput).data('media_type');

    this.hourglass = `<span id="loader_${this.context.context_id}" class="loader circle-spin fixed-center"></span>`;
  }

  init() {

    this.loaderInput = $(this.imageUploader).find('.loaderInput');
    this.saveButton = $(this.imageUploader).find('.loaderSave');
    this.image = $(this.imageUploader).find('.loaderImage');
    this.loaderPreview = $(this.imageUploader).find('.loaderPreview');
    this.loaderRotate = $(this.imageUploader).find('.loaderRotate');
    this.actionButtons = $(this.imageUploader).find('.actionButtons');

    this.id = $(this.imageUploader).attr('id');
    this.imagePreview = $(`*[data-open="${this.id}"]`).find('.imagePreview');

    this._setContext();

    $(`*[data-open="${this.id}"]`).on('click', (event) => $(this.imageUploader).foundation('open'));
    $(this.imageUploader).find('.close-button').on('click', (event) => $(this.imageUploader).foundation('close'));

    $(this.imageUploader).on('open.zf.reveal', (event) => {
      if (this.context.media_details.url) {
        if (this.croppie) {
          this.croppie.destroy();
          this.croppie = null;
        };

        $(this.image).attr('src', this.context.media_details.url);
        const croppie = this._setCroppie(this.image[0]);

        croppie.setZoom(0);

        // console.log(croppie);

        $(this.actionButtons).fadeIn(400);
        this._tooglePreview();

        this.croppie = croppie;
      }
    });

    $(this.imageUploader).on('close.zf.reveal', (event) => {
      if (this.croppie) {
        this.croppie.destroy();
        this.croppie = null;
      };
    });

    $(this.loaderInput).change(() => {
      this._getImageData(this.loaderInput);
      this._tooglePreview();
    });

    $(this.loaderRotate).on('click', event => {
      this.croppie.rotate(parseInt($(event.currentTarget).data('deg')));
    });

    $(this.saveButton).on('click', () => {
      this.croppie
        .result({
          type: 'canvas',
          format: 'jpeg',
          backgroundColor: '#ffffff',
          quality: '0.9',
          size: {
            width: 1200,
            height: 1200
          }
        })
        .then( dataImg => this._saveImage(dataImg) );
    });
  }

  _tooglePreview() {
    $(this.loaderPreview).hide();
  }

  _setCroppie(el, url = null) {
    return new Croppie(el, {
      viewport: { width: 260, height: 260, type: "square" },
      boundary: { width: 300, height: 300 },
      enforceBoundary: this.userBrowser.name === 'Safari' ? true : false,
      enableExif: true,
      zoom: 0,
      enableOrientation: true,
    });
  }

  _imageSaveRequest(base64Image) {
    let url = `/api/${this.context.lang}/${this.context.media_type}/${this.context.context_id}/store-picture`;

    let requestData = {
      "collection" : this.context.collection_name,
      "image_data": base64Image
    }

    if (this.context.media_details.url) {
      requestData.media_id = this.context.media_details.id;
    }

    return $.ajax({
      url: url,
      method: "POST",
      dataType: "JSON",
      headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
      },
      data: requestData
    });
  }

  _saveImage(dataImg) {
    let saveRequest = this._imageSaveRequest(dataImg);

    $(this.imageUploader).animate({opacity: 0}, 600, cb => {
      $(this.imageUploader).parent().append(this.hourglass);
    });

    saveRequest.done(data => {
      this.context.media_details.url = data.image_src;
      this.context.media_details.id = data.image_id;

      $(this.imagePreview).find('img').attr('src', this.context.media_details.url);
      $(this.imagePreview).fadeIn(600);

      $(this.imageUploader).css('opacity', 1);
      $(this.imageUploader).find('.loader').remove();
      $(this.imageUploader).foundation('close');

      $(this.loaderInput).attr({
        'filename': this.context.media_details.url,
        'id': this.context.media_details.id
      });

      if (this.context.collection_name == 'pictures') {
        /*
        TODO: This to work with many images
        thisNewBt.foundation();
        imageUploader.startedUploaders.push( new Uploader(thisNewBt.find('*[data-image-uploader]')[0]) );
        */
      }
    })
      .catch(err => console.log(err));
  }

  _getImageData(loaderInput) {
    loaderInput = loaderInput[0];
    // kill other croppies if exists
    if (this.croppie) {
      this.croppie.destroy();
      this.croppie = null;
    };

    if (loaderInput.files && loaderInput.files[0]) {
      let reader = new FileReader();

      $(this.actionButtons).fadeIn();

      reader.onload = (e) => {
        this.image.attr('src', e.target.result);

        this.croppie = this._setCroppie(this.image[0]);

        $(this.actionButtons).fadeIn();
        this._tooglePreviewevent;
      }

      reader.readAsDataURL(loaderInput.files[0]);
    }
  }
}

class FieldBoilerplate {

  constructor(fieldBoilerplate) {
    this.element = fieldBoilerplate;
    this.boilerplate = decodeHtml( $(this.element).data('field-boilerplate') );


    $(this.element).attr('data-field-boilerplate', '');

    $(this.element).on('click', event => {
      event.preventDefault();
      let newInput = this._createField();

      let uploader = new Uploader($(newInput).find('*[data-image-uploader]'));
      $(event.target).parentsUntil('.shrink').last().parent().before(newInput);
      newInput.foundation();

      uploader.imagePreview = this.imagePreview;

      $(uploader.imageUploader).foundation('open');
    })
  }

  _uniqueID() {
    return `input_${Math.random().toString(36).substr(2, 9)}`
  };

  _createField() {
    let id = this._uniqueID();
    let newField = $(this.boilerplate).clone();

    newField.find('div[id]').attr('id', id);
    newField.find('*[data-open]').attr('data-open', id);

    this.imagePreview = newField.find('.imagePreview');

    return newField;
  }

}

class ImageUploader {

  constructor() {
    this.startedUploaders = [];
    this.startedBoilerplates = [];

    const imageUploaders = $('*[data-image-uploader]');
    if (imageUploaders.length) {
      imageUploaders.each((index, imageUploader) => {
        this.startedUploaders.push(new Uploader(imageUploader));
      });
    }

    const fieldBoilerplates = $('*[data-field-boilerplate]');
    if (fieldBoilerplates.length) {
      fieldBoilerplates.each((index, fieldBoilerplate) => {
        this.startedBoilerplates.push(new FieldBoilerplate(fieldBoilerplate));
      });
    }
  }
}

export default new ImageUploader;
